<template>
  <aside
    v-if="type === ContainerType.ASIDE"
    class="grid gap-6 lg:col-start-2 lg:row-start-1 self-start lg:sticky top-4"
    :class="[
      asideClass,
      // TODO do we need to handle this?
      $route.meta.pageType === PageTypes.LANDING && sectionIndex === 0 ? 'lg:mt-44' : 'lg:mt-0.5',
    ]"
  >
    <MSlice v-for="(slice, i) in slices" :key="i" :slice="slice" />
  </aside>
  <MSlice v-else-if="type === ContainerType.FREE" :slice="slices[0]" />
  <div v-else class="boxed boxed-content">
    <MSlice v-for="(slice, i) in slices" :key="i" :slice="slice" no-wrapper-class />
  </div>
</template>

<script lang="ts" setup>
import { PageTypes } from '@core/constants/pages'
import { ContainerType, type Slice } from './types'
import MSlice from './m-slice.vue'

const props = defineProps<{
  slices: Slice[]
  type: ContainerType
  sectionIndex: number
}>()

const asideClass = computed(() => {
  switch (props.slices[0].type) {
    case 'TransferSearchFormSlice':
      return 'lg:z-20'
    case 'EntityScoreSummarySlice':
      return 'mt-18 lg:mt-0 lg:top-14'
  }
  return ''
})
</script>
